import React, { useEffect, useMemo, useRef, useState, useImperativeHandle, forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import styles from './nodeRender.module.less';
import { Tooltip } from 'antd';

interface NodeRenderProps {
  handleNodeClick: any;
  data: any;
  currentSelectNode: any;
}

const NodeRender: ForwardRefExoticComponent<PropsWithoutRef<NodeRenderProps> & RefAttributes<Record<any, any>>> = forwardRef((
  {
    handleNodeClick,
    currentSelectNode,
    data,
  },
  ref,
) => {
  const selected = currentSelectNode?.id === data?.id;

  return (
    <div
      className={`${styles.custom_box} ${selected ? styles.custom_box_selected : ''}`}
    >
      <div
        className={styles.left_line}
        style={data.disabled ? { background: '#ADADAD' } : {}}
      />
      <div
        className={styles.label_box}
        style={data.disabled ? { color: '#666666' } : { cursor: 'pointer' }}
        onClick={() => {
          if (!data.disabled) {
            handleNodeClick(data, selected);
          }
        }}
      >
        {data.label}
      </div>
    </div>
  );
});
export default NodeRender;
